import WarningIcon from "@mui/icons-material/Warning";
import { Box, Button, Dialog, DialogActions, DialogContent, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import DialogTitle from "../../componentLibrary/DialogTitle";

interface ArchiveModalProps {
  onClose: () => void;
  open: boolean;
  onArchive: () => void;
  archived: boolean;
  synced: boolean;
}

const ArchiveModal = ({ onClose, open, onArchive, archived, synced }: ArchiveModalProps) => {
  const { t } = useTranslation();

  const handleArchive = () => {
    onArchive();
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle title={t(archived ? "universal.archiveModal.unarchiveTitle" : "universal.archiveModal.archiveTitle")} onClose={onClose} />
      <DialogContent>
        <Typography>{t(archived ? "universal.archiveModal.unarchiveQuestion" : "universal.archiveModal.archiveQuestion")}</Typography>
        {synced && (
          <Box sx={{ p: 2, mt: 2, backgroundColor: "grey.200", borderRadius: "5px", display: "flex", alignItems: "center", gap: 2 }}>
            <WarningIcon />
            <Typography variant="body2">This will cause your org to lose fully synced status.</Typography>
          </Box>
        )}
        {!archived && (
          <Typography>
            {t("universal.archiveModal.archiveDescription")}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={onClose}>
          Cancel
        </Button>
        <Button onClick={handleArchive}>{t(archived ? "universal.archiveModal.unarchiveButton" : "universal.archiveModal.archiveButton")}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ArchiveModal;
